<div class="navigation-button">
  <ng-container *ngIf="!isButton && !hasEmit">
    <a
      *ngIf="routerLinkButton"
      app-vtmn-play-button
      [ngClass]="buttonClass"
      [queryParams]="queryParameters"
      [queryParamsHandling]="queryParametersHandling"
      [routerLink]="routerLinkButton"
      [variant]="variant"
      [shape]="shape"
      [size]="size"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>

    <a
      *ngIf="href"
      app-vtmn-play-button
      [ngClass]="buttonClass"
      [href]="href"
      [variant]="variant"
      [shape]="shape"
      [size]="size"
      target="_blank"
      [rel]="'noopener noreferrer'"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  </ng-container>

  <button
    *ngIf="isButton || hasEmit"
    app-vtmn-play-button
    type="submit"
    [ngClass]="buttonClass"
    [disabled]="disabled ? true : null"
    [attr.data-disabled]="disabled ? true : null"
    [variant]="variant"
    [shape]="shape"
    [size]="size"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
